import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { Mail } from "lucide-react";
import Inbox from "./index";
import { MODULE_INBOX } from "variables/constants";

const inboxRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Inbox",
        basePath: "inbox",
        mainComponent: <Inbox />,
        layout: "/console",	   
        icon: <Mail className="icon-item" />,
        subTitle:"Inbox",
        level:5,
        moduleId: MODULE_INBOX,
    })
]

export default inboxRoutes;